import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import Form                         from "react-jsonschema-form";
import { schema, uiSchema }         from "../../components/assessment/schema/Girth"
import { invokeSetAddGirthAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import '../../css/assessment/HeartAndBloodForm.css';

//const log = (type) => console.log.bind(console, type);
// FORM DOCS: https://react-jsonschema-form.readthedocs.io/en/latest/#react-jsonschema-form

const onError = (errors) => console.log("I have", errors.length, "errors to fix");

let assess_form;

export default class HeartAndBloodForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            userFormData: {}
        }

       this.setUserFormData = this.setUserFormData.bind(this);
    }

    async componentWillMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getGirthAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

            if(results) {
                var upper_chest      = results.data[0].upper_chest;
                var lower_chest      = results.data[0].lower_chest
                var abdomen          = results.data[0].abdomen
                var waist            = results.data[0].waist
                var hip              = results.data[0].hip;
                var thigh_right      = results.data[0].thigh_right;
                var thigh_left       = results.data[0].thigh_left;
                var calf_right       = results.data[0].calf_right;
                var calf_left        = results.data[0].calf_left;
                var arm_right        = results.data[0].arm_right;
                var arm_left         = results.data[0].arm_left;
                var arm_flexed_right = results.data[0].arm_flexed_right;
                var arm_flexed_left  = results.data[0].arm_flexed_left;
                var forearm_right    = results.data[0].forearm_right;
                var forearm_left     = results.data[0].forearm_left;
                var neck             = results.data[0].neck;
                var shoulder         = results.data[0].shoulder;
                /*
                upper_chest, lower_chest, abdomen, waist,
                hip, thigh_right, thigh_left, calf_right,
                calf_left, arm_right, arm_left, arm_flexed_right,
                arm_flexed_left, forearm_right, forearm_left, neck,
                shoulder */

                this.setState({
                    userFormData: {
                        upper_chest:        upper_chest,
                        lower_chest:        lower_chest,
                        abdomen:            abdomen,
                        waist:              waist,
                        hip:                hip,
                        thigh_right:        thigh_right,
                        thigh_left:         thigh_left,
                        calf_right:         calf_right,
                        calf_left:          calf_left,
                        arm_right:          arm_right,
                        arm_left:           arm_left,
                        arm_flexed_right:   arm_flexed_right,
                        arm_flexed_left:    arm_flexed_left,
                        forearm_right:      forearm_right,
                        forearm_left:       forearm_left,
                        neck:               neck,
                        shoulder:           shoulder
                    }
                });
            }
            //this.setUserFormData();
        } else {
            this.setUserFormData("","","","","","","","","","","","","","","","","");
        }
    }

    setUserFormData(upper_chest, lower_chest, abdomen, waist, hip, thigh_right, thigh_left, calf_right, calf_left, arm_right, arm_left, arm_flexed_right, arm_flexed_left, forearm_right, forearm_left, neck, shoulder) {
        this.setState({
            userFormData: {
                upper_chest:        upper_chest,
                lower_chest:        lower_chest,
                abdomen:            abdomen,
                waist:              waist,
                hip:                hip,
                thigh_right:        thigh_right,
                thigh_left:         thigh_left,
                calf_right:         calf_right,
                calf_left:          calf_left,
                arm_right:          arm_right,
                arm_left:           arm_left,
                arm_flexed_right:   arm_flexed_right,
                arm_flexed_left:    arm_flexed_left,
                forearm_right:      forearm_right,
                forearm_left:       forearm_left,
                neck:               neck,
                shoulder:           shoulder
            }
        });
    }

    isObject(obj) {
        return obj != null && obj.constructor.name === "Object"
    }

    onSubmit = async (formData) => {
        var client_id        = this.props.clientId;
        var assessment_id    = this.props.assessmentId;
        var assessment_type  = 12; // GIRTH is #12 in dropdown
        var action           = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })

        var obj = this.getObjectData(formData);

        var upper_chest         = obj.upper_chest;
        var lower_chest         = obj.lower_chest;
        var abdomen             = obj.abdomen;
        var waist               = obj.waist;
        var hip                 = obj.hip;
        var thigh_right         = obj.thigh_right;
        var thigh_left          = obj.thigh_left;
        var calf_right          = obj.calf_right;
        var calf_left           = obj.calf_left;
        var arm_right           = obj.arm_right;
        var arm_left            = obj.arm_left;
        var arm_flexed_right    = obj.arm_flexed_right;
        var arm_flexed_left     = obj.arm_flexed_left;
        var forearm_right       = obj.forearm_right;
        var forearm_left        = obj.forearm_left;
        var neck                = obj.neck;
        var shoulder            = obj.shoulder;

        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddGirthAssessment(action, assessment_id, client_id, upper_chest, lower_chest, abdomen, waist, hip, thigh_right, thigh_left, calf_right, calf_left, arm_right, arm_left, arm_flexed_right, arm_flexed_left, forearm_right, forearm_left, neck, shoulder)

            if(results2.status === true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }

    getObjectData = (formData) => {
        var upper_chest;
        var lower_chest;
        var abdomen
        var waist;
        var hip;
        var thigh_right;
        var thigh_left;
        var calf_right;
        var calf_left;
        var arm_right;
        var arm_left;
        var arm_flexed_right;
        var arm_flexed_left;
        var forearm_right;
        var forearm_left;
        var neck;
        var shoulder;

        for(var key in formData) {
            var formData2 = formData[key];
            for(var key2 in formData2) {
                var data = formData2[key2];

                if(key2 === "upper_chest" && this.isObject(data) == false) {
                    upper_chest = data;
                } else if(key2 === "lower_chest" && this.isObject(data) == false) {
                    lower_chest = data;
                } else if(key2 === "abdomen" && this.isObject(data) == false) {
                    abdomen = data;
                } else if(key2 === "waist" && this.isObject(data) == false) {
                    waist = data;
                } else if(key2 === "hip" && this.isObject(data) == false) {
                    hip = data;
                } else if(key2 === "thigh_right" && this.isObject(data) == false) {
                    thigh_right = data;
                } else if(key2 === "thigh_left" && this.isObject(data) == false) {
                    thigh_left = data;
                } else if(key2 === "calf_right" && this.isObject(data) == false) {
                    calf_right = data;
                } else if(key2 === "calf_left" && this.isObject(data) == false) {
                    calf_left = data;
                } else if(key2 === "arm_right" && this.isObject(data) == false) {
                    arm_right = data;
                } else if(key2 === "arm_left" && this.isObject(data) == false) {
                    arm_left = data;
                } else if(key2 === "arm_flexed_right" && this.isObject(data) == false) {
                    arm_flexed_right = data;
                } else if(key2 === "arm_flexed_left" && this.isObject(data) == false) {
                    arm_flexed_left = data;
                } else if(key2 === "forearm_right" && this.isObject(data) == false) {
                    forearm_right = data;
                } else if(key2 === "forearm_left" && this.isObject(data) == false) {
                    forearm_left = data;
                } else if(key2 === "neck" && this.isObject(data) == false) {
                    neck = data;
                } else if(key2 === "shoulder" && this.isObject(data) == false) {
                    shoulder = data;
                }
            }
        }

        var obj = {};

        obj.upper_chest         = upper_chest;
        obj.lower_chest         = lower_chest;
        obj.abdomen             = abdomen;
        obj.waist               = waist;
        obj.hip                 = hip;
        obj.thigh_right         = thigh_right;
        obj.thigh_left          = thigh_left;
        obj.calf_right          = calf_right;
        obj.calf_left           = calf_left;
        obj.arm_right           = arm_right;
        obj.arm_left            = arm_left;
        obj.arm_flexed_right    = arm_flexed_right;
        obj.arm_flexed_left     = arm_flexed_left;
        obj.forearm_right       = forearm_right;
        obj.forearm_left        = forearm_left;
        obj.neck                = neck;
        obj.shoulder            = shoulder;


        return obj;
    }

    onChange = (formData) => {
        var obj = this.getObjectData(formData);

        var upper_chest         = obj.upper_chest;
        var lower_chest         = obj.lower_chest;
        var abdomen             = obj.abdomen;
        var waist               = obj.waist;
        var hip                 = obj.hip;
        var thigh_right         = obj.thigh_right;
        var thigh_left          = obj.thigh_left;
        var calf_right          = obj.calf_right;
        var calf_left           = obj.calf_left;
        var arm_right           = obj.arm_right;
        var arm_left            = obj.arm_left;
        var arm_flexed_right    = obj.arm_flexed_right;
        var arm_flexed_left     = obj.arm_flexed_left;
        var forearm_right       = obj.forearm_right;
        var forearm_left        = obj.forearm_left;
        var neck                = obj.neck;
        var shoulder            = obj.shoulder;

        this.setUserFormData(upper_chest, lower_chest, abdomen, waist, hip, thigh_right, thigh_left, calf_right, calf_left, arm_right, arm_left, arm_flexed_right, arm_flexed_left, forearm_right, forearm_left, neck, shoulder);
    }

    render() {

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <Form style      = {{textAlign:"left", fontSize: "20px !important"}}
                      className  = "assessmentHeartAndBloodForm"
                      schema     = {schema}
                      uiSchema   = {uiSchema}
                      formData   = {this.state.userFormData}
                      onChange   = {this.onChange} ref={(form) => {assess_form = form}}
                      onSubmit   = {this.onSubmit} ref={(form) => {assess_form = form}}
                      noValidate = {true}
                >
                    <Row className="grid" >
                          <Col xs={6} sm={6} md={6}>
                                <span onClick = { () => this.props.cancelAssessment()}
                                    style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        type    = "button"
                                        text    = "Cancel"
                                        style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                      />
                                </span>
                          </Col>
                          <Col xs={6} sm={6} md={6}>
                                <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                        //disabled={!this.validateForm()}
                                        isLoading={this.state.isLoading}
                                        text    = "Save"
                                        type    = "submit"
                                        loadingText="Saving …"
                                      />
                                </span>
                            </Col>
                     </Row>
             </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/GirthForm.js